import { useState } from "react"

import DescriptionMarkdown from "areas/collection/description-markdown"
import useCollection from "areas/collection/hoc/use-collection"
import Button from "components/ui/button"

const Description = () => {
  const [showDescription, toggleDescription] = useState(false)
  const { data } = useCollection()
  const longSubtitle = data?.long_subtitle
  const subtitle = data?.subtitle
  const subtitleType = data?.subtitle_type

  return (
    <div>
      {["markdown", "spreadsheet"].includes(subtitleType) ? (
        <DescriptionMarkdown classNames={{ paragraphClassName: "inline" }}>
          {showDescription ? longSubtitle : subtitle}
        </DescriptionMarkdown>
      ) : (
        <p className="text-15 tablet:text-18 inline">
          {showDescription ? `${subtitle} ${longSubtitle}` : subtitle}
        </p>
      )}
      {!!longSubtitle && (
        <Button
          className="text-grey-65 ml-2"
          onClick={() => toggleDescription(!showDescription)}
          text
          underline
        >
          {showDescription ? "Less" : "More"}
        </Button>
      )}
    </div>
  )
}

export default Description
